var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _polyline, _line, _line2, _line3, _circle3, _circle4, _line4, _line5, _circle5, _path16, _circle6, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "001-business") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 145,
    height: 145,
    fill: "none",
    id: "id_101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.12,117H58.85a0.72,0.72,0,0,1,.72.72v12.83H25.78V117.7A0.72,0.72,0,0,1,26.5,117h6.62Z",
    fill: "#a8cbeb",
    id: "id_102"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.84,117h28a0.72,0.72,0,0,1,.72.72v12.83H68.82V117.7a0.72,0.72,0,0,1,.72-0.72h4.3Z",
    fill: "#a8cbeb",
    id: "id_103"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.7,78l-0.62.53c-0.26.22-.55,0.46-0.84,0.71h0L102.59,63.6a10.8,10.8,0,0,1,5.69-10l2.23-1.2a0.43,0.43,0,0,1,.68.33V58a13.43,13.43,0,0,0-.73,2.82Z",
    fill: "#fff",
    id: "id_104"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.46,83.81l0.19,0.11,0.21-.18c1.51-1.27,3.62-3,5.37-4.46,0.29-.26.58-0.49,0.84-0.71L104.7,78l5.77-17.22a13.43,13.43,0,0,1,.73-2.82,15.34,15.34,0,0,1,5-7.3c2.18-1.56,6-2.92,7.12-1.67a1.66,1.66,0,0,1,.3,1.28q-3.08,13.7-6.17,27.42c-2.66,5-5.68,10.22-9.14,15.64-4.22,6.63-12.71,18-12.76,18L95.28,117H73.84l-0.3-5.73A71.66,71.66,0,0,1,74,96.44L74.34,94A12.22,12.22,0,0,1,78.84,86L96.55,71.9a0.15,0.15,0,0,1,.21,0,10.65,10.65,0,0,1,.89,11.56Z",
    fill: "#fff",
    id: "id_105"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,63.6L25.17,79.26l-0.85-.7L23.7,78,17.94,60.81A14.53,14.53,0,0,0,17.21,58V52.75a0.43,0.43,0,0,1,.68-0.33l2.24,1.2A10.81,10.81,0,0,1,25.8,63.6Z",
    fill: "#fff",
    id: "id_106"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.93,83.81l-0.18-.33a10.63,10.63,0,0,1,.9-11.56,0.14,0.14,0,0,1,.2,0L49.56,86A12.24,12.24,0,0,1,54.06,94l0.34,2.49a72.23,72.23,0,0,1,.46,14.82L54.55,117H33.12l-0.3-5.62S24.3,100,20.06,93.36c-3.46-5.42-6.48-10.66-9.13-15.64L4.76,50.3A1.66,1.66,0,0,1,5.06,49c1.07-1.25,4.94.11,7.13,1.67a15.4,15.4,0,0,1,5,7.3,14.53,14.53,0,0,1,.73,2.82L23.7,78l0.62,0.53,0.85,0.7,5.36,4.47,0.22,0.18Z",
    fill: "#fff",
    id: "id_107"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.32,44.26a20.4,20.4,0,1,0,20.4-20.4A20.4,20.4,0,0,0,43.32,44.26Zm20.4,27.6a27.6,27.6,0,1,1,27.6-27.6A27.6,27.6,0,0,1,63.72,71.86Z",
    fill: "#fff",
    id: "id_108"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.72,
    cy: 44.26,
    r: 19.6,
    fill: "#ed9180",
    id: "id_109"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.63,92.7l10.51-8.38,0.32-.52,0.18-.33a10.65,10.65,0,0,0-.89-11.56,0.15,0.15,0,0,0-.21,0L78.84,86A12.22,12.22,0,0,0,74.34,94L74,96.44a71.66,71.66,0,0,0-.46,14.82l0.3,5.73v0.18",
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_110"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.66,83.92l0.21-.18c1.51-1.27,3.62-3,5.37-4.46,0.29-.26.58-0.49,0.84-0.71L104.7,78l5.77-17.22a13.43,13.43,0,0,1,.73-2.82,15.34,15.34,0,0,1,5-7.3c2.18-1.56,6-2.92,7.12-1.67a1.66,1.66,0,0,1,.3,1.28q-3.08,13.7-6.17,27.42c-2.66,5-5.68,10.22-9.14,15.64-3.91,6.13-11.46,16.29-12.61,17.82a0.8,0.8,0,0,0-.16.44L95.28,117",
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.22,79.26L102.59,63.6a10.8,10.8,0,0,1,5.69-10l2.23-1.2a0.43,0.43,0,0,1,.68.33V58",
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_112"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.76,92.7l-10.5-8.38-0.33-.52-0.18-.33a10.63,10.63,0,0,1,.9-11.56,0.14,0.14,0,0,1,.2,0L49.56,86A12.24,12.24,0,0,1,54.06,94l0.34,2.49a72.23,72.23,0,0,1,.46,14.82L54.55,117v0.18",
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_113"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.74,83.92l-0.22-.18-5.36-4.47-0.85-.7L23.7,78,17.94,60.81A14.53,14.53,0,0,0,17.21,58a15.4,15.4,0,0,0-5-7.3C10,49.14,6.13,47.78,5.06,49a1.66,1.66,0,0,0-.3,1.28l6.18,27.42c2.65,5,5.67,10.22,9.13,15.64,3.91,6.13,11.46,16.29,12.61,17.82a0.8,0.8,0,0,1,.16.44L33.12,117v0.18",
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_114"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.17,79.26L25.8,63.6a10.81,10.81,0,0,0-5.68-10l-2.24-1.2a0.43,0.43,0,0,0-.68.33V58",
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_115"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.72,
    cy: 44.26,
    r: 27.6,
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_116"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.92,43.86c2.87,0,5.2,2.06,5.2,4.6s-2.33,4.6-5.2,4.6-5.2-2.06-5.2-4.6",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_117"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.12,39.26c0-2.54-2.33-4.6-5.2-4.6H63.86c-2.83,0-5.14,2.07-5.14,4.6s2.34,4.6,5.2,4.6",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_118"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "63.86 32.34 63.86 34.66 63.86 34.74",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_119"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 63.86,
    y1: 53.14,
    x2: 63.86,
    y2: 55.54,
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 123.32,
    y1: 34.6,
    x2: 126.52,
    y2: 37.8,
    fill: "none",
    stroke: "#ed9180",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 126.52,
    y1: 34.6,
    x2: 123.32,
    y2: 37.8,
    fill: "none",
    stroke: "#ed9180",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.66,
    cy: 41.8,
    r: 2,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    id: "id_120"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.26,
    cy: 54.34,
    r: 1.6,
    fill: "#b8b9ba",
    id: "id_121"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 113,
    x2: 13,
    y2: 120,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 117,
    x2: 10,
    y2: 117,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.52,
    cy: 15.86,
    r: 1.6,
    fill: "#b8b9ba",
    id: "id_122"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,26l2.33-1.22a0.08,0.08,0,0,1,.12.08L31.4,27.42l2,1.95-2.76.4-1.24,2.5-1.24-2.5-2.6-.38a0.08,0.08,0,0,1,0-.14l1.88-1.84-0.47-2.75Z",
    fill: "#a8cbeb",
    id: "id_123"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.86,
    cy: 102.74,
    r: 1.6,
    fill: "#b8b9ba",
    id: "id_124"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.66,124.79a2.4,2.4,0,0,1,2.29-2.4l27.31-2.06V118.5a0.57,0.57,0,0,0-.57-0.57H27.3a0.55,0.55,0,0,0-.65.57v12.23h4v-5.94Z",
    fill: "#d2e1ef",
    id: "id_125"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.57,130.54V117.7a0.72,0.72,0,0,0-.72-0.72H26.5a0.72,0.72,0,0,0-.72.72v12.83",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_126"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.35,124.79a2.4,2.4,0,0,1,2.29-2.4L103,120.34V118.5a0.57,0.57,0,0,0-.57-0.57H70a0.55,0.55,0,0,0-.65.57v12.23h4v-5.94Z",
    fill: "#d2e1ef",
    id: "id_127"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.82,130.54V117.7a0.72,0.72,0,0,1,.72-0.72h32.34a0.72,0.72,0,0,1,.72.72v12.83",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4,
    id: "id_128"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/$.d191f4ef7eab3e9c041d24197c1f429f.svg";
export { ForwardRef as ReactComponent };